import { createFileRoute } from '@tanstack/react-router'
import { ActionList } from '@/components/events'

export const Route = createFileRoute('/events/actions/')({
  staticData: {
    title: 'Actions',
    isSecured: true,
  },
  component: ActionList,
})
